module.exports = __webpack_public_path__ + "img/replay.be19a1e8.png";